//POSTS
export const SEARCH = 'SEARCH';
export const CREATE = 'CREATE';
export const UPDATE = 'UPDATE';
export const DELETE = 'DELETE';
export const FETCH_ALL = 'FETCH_ALL';
export const FETCH_MORE = 'FETCH_MORE';
export const FETCH_POST = 'FETCH_POST'; 
export const FETCH_SIMILAR = 'FETCH_SIMILAR'; 
export const LIKE = 'LIKE';

//Auth
export const AUTH = 'AUTH'; 
export const LOGOUT = 'LOGOUT';
export const REPOPULATE = 'REPOPULATE'; 

//EXPLORE
export const FETCH_TRENDING_POSTS = 'FETCH_TRENDING_POSTS';

//TAGS
export const FETCH_TAGS = 'FETCH_TAGS'; 

//USER
export const FETCH_PROFILE = 'FETCH_PROFILE';
export const UPDATE_PROFILE = 'UPDATE_PROFILE';
export const FOLLOW_USER = 'FOLLOW_USER'; 
export const UNFOLLOW_USER = 'UNFOLLOW_USER';
export const FETCH_SUGGESTED_USERS = 'FETCH_SUGGESTED_USERS';
export const FETCH_FOLLOWING = 'FETCH_FOLLOWING';
export const FETCH_FOLLOWERS = 'FETCH_FOLLOWERS';
export const SEARCH_USERS = 'SEARCH_USERS';

//USER POSTS
export const FETCH_USER_POSTS = 'FETCH_USER_POSTS';
export const FETCH_MORE_USER_POSTS = 'FETCH_MORE_USER_POSTS';

//LOADING 
export const START_LOADING = 'START_LOADING'; 
export const END_LOADING = 'END_LOADING';
export const START_LOADING_SEARCH = 'START_LOADING_SEARCH'; 
export const END_LOADING_SEARCH = 'END_LOADING_SEARCH';
export const START_LOADING_EXPLORE = 'START_LOADING_EXPLORE'; 
export const END_LOADING_EXPLORE = 'END_LOADING_EXPLORE';
export const START_LOADING_PROFILE = 'START_LOADING_PROFILE'; 
export const END_LOADING_PROFILE = 'END_LOADING_PROFILE';
export const START_LOADING_USER_POSTS = 'START_LOADING_USER_POSTS'; 
export const END_LOADING_USER_POSTS = 'END_LOADING_USER_POSTS';

//COMMENT
export const COMMENT = 'COMMENT';

//SOCKET MANAGEMENT
export const CREATE_SOCKET = 'CREATE_SOCKET';
export const CLOSE_SOCKET = 'CLOSE_SOCKET';
export const GET_SOCKET = 'GET_SOCKET'; 

//NOTIFICATIONS
export const FETCH_HISTORIC_NOTIFICATIONS = 'FETCH_HISTORIC_NOTIFICATIONS'; 
export const FETCH_MORE_HISTORIC_NOTIFICATIONS = 'FETCH_MORE_HISTORIC_NOTIFICATIONS';
export const MARK_NOTIFICATIONS_AS_READ = 'MARK_NOTIFICATIONS_AS_READ;'//notifications will be marked as read in batch to save on api calls

//NOTIFICATIONS VIA SOCKET
export const NOTIFICATION_FROM_SOCKET = 'NOTIFICATION_FROM_SOCKET';

//DYNAMIC UI -- For showing popup UI components during runtime
export const SHOW_NOTIFICATIONS = 'SHOW_NOTIFICATIONS';
export const SHOW_PROFILE_MENU = 'SHOW_PROFILE_MENU';
export const SHOW_CREATE_POST = 'SHOW_CREATE_POST';
export const SHOW_EDIT_POST = 'SHOW_EDIT_POST';
export const PROMPT_USER = 'PROMPT_USER'; 

//ChatUI -- For showing Chat UI components 
export const SHOW_CHAT = 'SHOW_CHAT';
export const SHOW_CHAT_NOTIFICATIONS = 'SHOW_CHAT_NOTIFICATIONS';

//CHAT - MENU
export const GET_ONLINE_USERS = 'GET_ONLINE_USERS';
export const GET_CHATS = 'GET_CHATS'; 


//CHAT - INDIVIDUAL CHAT INSTANCE
export const FETCH_HISTORIC_MESSAGES = 'FETCH_HISTORIC_MESSAGES'; //for individual chatroom
export const FETCH_MORE_HISTORIC_MESSAGES = 'FETCH_MORE_HISTORIC_MESSAGES';
export const MARK_MESSAGE_AS_READ = 'MARK_MESSAGE_AS_READ';
export const SEND_MESSAGE = 'SEND_MESSAGE';
export const START_CHAT = 'START_CHAT';

//CHAT VIA SOCKET - INDIVIDUAL CHAT INSTANCE
export const MESSAGE_FROM_SOCKET = 'MESSAGE_FROM_SOCKET';

